<template>
  <v-card outlined>
    <v-card-title class="text-h6">Tank Status</v-card-title>
    <v-card-text>
      <ul v-if="tankStatus !== null">
        <li>
          <span>{{ `Name: ${tank.tankName}` }}</span>
        </li>
        <li>
          <span>{{ `Bulk: ${tankStatus.bulk}` }}</span>
        </li>
        <li>
          <span>{{
            `Current Quantity: ${tankStatus.quantityOnBoard}
                      ${tank.qtyUom}`
          }}</span>
        </li>
        <li>
          <span>{{ `Fill Percent: ${tankStatus.fillPercent}%` }}</span>
        </li>
        <li>
          <span>{{
            `Recorded At (LT): ${$options.filters.removeTAndSecondsAndFormatDate(
              tankStatus.statusDateTimeLt
            )}`
          }}</span>
        </li>
      </ul>
      <span v-else class="error--text"
        >No recording history found for Tank:
        <strong>{{ tank.tankName }}</strong
        >. Tank status updates are disabled.</span
      >
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TankStatusOverviewCard',
  props: ['tank', 'tankStatus'],
};
</script>
